/*
* Куда возвращает «К заказам» с карточки заказа: фильтры лежат в query списка, и
* `push("/stats/list")` открыл бы его без них. Пусто — карточку открыли по прямой ссылке, ведём
* на чистый список.
*
* Переменная модуля, а не стор: это состояние сессии интерфейса (так же сделан «показать попап
* тарифа один раз за сессию»).
* */
let lastSearch = "";

export const rememberOrdersSearch = (search: string) => {
    lastSearch = search;
};

export const ordersListLocation = () => `/stats/list${lastSearch}`;
